import { BaseEntity } from "yt-ng-framework";

export class KalendarNeradnihDana extends BaseEntity{
    constructor(){
        super();
    }


Datum: Date = null;
// FirmaID: number = null;
// OsobaID: number = null;
Opis: string = null;

Deserialize(input: any){
    this.Datum = input.Datum;
    // this.FirmaID = input.FirmaID;
    // this.OsobaID = input.OsobaID;
    this.Opis = input.Opis;

    return this;
} 

Serialize(input: KalendarNeradnihDana){
    return input;
}

// GetInstance(){
//     return this;
// }
}
